// Reusable multilingual input block: one row per site language.
// `field` is the formData key (e.g. "name"); each input is named `field.lang`
// so the existing handleInputChange (which splits on ".") keeps working.
// Kazakh is optional — en/ru stay the required languages.
const LANGS = [
  { code: "en", label: "English" },
  { code: "ru", label: "Русский" },
  { code: "kk", label: "Қазақша" },
];

const INPUT_CLS =
  "mt-1 w-full rounded-md border-0 py-1.5 px-4 text-neutral-900 ring-1 ring-inset ring-neutral-300 placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6";

export default function LangInputs({
  label,
  field,
  values,
  onChange,
  textarea = false,
  placeholders = {},
}) {
  const Cmp = textarea ? "textarea" : "input";
  return (
    <div className="w-full">
      <div className="block text-sm font-medium text-neutral-700">{label}</div>
      <div className="mt-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {LANGS.map((l) => (
          <div key={l.code}>
            <span className="block text-xs text-neutral-400 mb-0.5">
              {l.label}
              {l.code === "kk" ? " (необязательно)" : ""}
            </span>
            <Cmp
              type="text"
              name={`${field}.${l.code}`}
              className={INPUT_CLS}
              placeholder={placeholders[l.code] || ""}
              value={values?.[l.code] || ""}
              onChange={onChange}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
